<template>
  <aside>
    <b-nav
      vertical>
      <b-nav-text
        class="text-uppercase text-muted">
        {{ userName }}
      </b-nav-text>
      <b-nav-item
        to="/dashboard">
        <i class="noOutline ti-dashboard mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.dashboard') }}</span>
      </b-nav-item>
      <b-nav-item
        v-if="isPolicyHolder"
        to="/contracts">
        <i class="noOutline ti-receipt mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.contracts') }}</span>
      </b-nav-item>
      <b-nav-item
        v-if="isPolicyHolder"
        to="/contactpersons">
        <i class="noOutline ti-user mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.contactPersons') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/addresses">
        <i class="noOutline ti-home mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.addresses') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/faq">
        <i class="noOutline ti-help mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.faq') }}</span>
      </b-nav-item>
      <b-nav-item
        to="/account">
        <i class="noOutline ti-settings mx-2"></i>
        <span>{{ $t('message.appSidebar.navItem.account') }}</span>
      </b-nav-item>
      <div
        v-if="isContactPerson && policyHolders.length > 0">
        <hr>
        <b-nav-text class="text-muted">
          {{ $t('message.appSidebar.navItem.contactPersonOf') }}
        </b-nav-text>
        <b-nav-item v-for="policyHolder in policyHolders"
                    :key="policyHolder.id"
                    :to="'/policyHolders/' + policyHolder.id">
          <i class="ti-user mx-2" v-if="!policyHolder.dateOfDeath"></i>
          <img class="cross mx-2" src="@/assets/cross.png" width="16" v-if="policyHolder.dateOfDeath"/>
          {{ policyHolder.firstName + ' ' + policyHolder.lastName }}
        </b-nav-item>
      </div>
    </b-nav>
  </aside>
</template>

<script>
  export default {
    name: 'AppSidebar',
    computed: {
      isContactPerson () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesContactPerson = currentUser.roles.filter(role => role.roleOfUser === 'CONTACT_PERSON')
          if (rolesContactPerson.length > 0) {
            return true
          }
        }
        return false
      },
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      },
      policyHolders () {
        return this.$store.getters.policyHolders
      },
      userName () {
        const currentUser = this.$store.getters.currentUser
        return `${currentUser.firstName} ${currentUser.lastName}`
      }
    },
    created () {
      if (this.$store.getters.policyHolders.length === 0 && this.isContactPerson) {
        this.$store.dispatch('fetchPolicyHolders')
      }
    }
  }
</script>

<style scoped>
  .cross {
    padding-bottom: 2px;
  }
  .noOutline:-moz-focus-inner {
    border: 0px;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AppSidebar.vue